module.exports = __webpack_public_path__ + "media/images/web/home/index/specs/other-33e7131cc006af1e3eef7ca99089c136.svg";